// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	message: '',
	error: false,
	show: false,
};

function errorReceived(state, payload) {
	if (payload) {
		let message = '';
		if (payload.hasOwnProperty('message')) {
			message = payload.message;
		} else if (typeof payload === 'string') {
			message = payload;
		}
		return {...state, message: message, error: true, show: true};
	}

	return {...state, message: '', error: false, show: false};
}

function msgReceived(state, payload) {
	if (payload.hasOwnProperty('message')) {
		return {...state, message: payload.message, error: false, show: true};
	}

	return {...state, message: '', error: false, show: false};
}

function clearErrors() {
	return {...defaultState};
}

export default function errorsReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.RECV_ERROR:
			return errorReceived(state, action.payload);
		case actionTypes.RECV_MSG:
			return msgReceived(state, action.payload);
		case actionTypes.CLEAR_ERROR:
			return clearErrors();
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/errors.js
 **/